const AnalyticsEventTypes = {
  SHOPPING_EVENT: 'click_navShoppingMenu',
  CLICK_NAV_FOOTER: 'click_navFooter',
  CLICK_HELP_MENU: 'click_navHelpMenu',
  CLICK_NAV_MEMBERSHIP: 'click_navMembership',
  CLICK_NAV_ACCOUNT: 'click_navAccount',
  CLICK_BRAND_BAR: 'click_navBrandBar',
  CLICK_GEO_MISMATCH_DISMISS: 'click_geoMismatchDismiss',
  CLICK_HEADER_LOGO: 'click_headerLogo',
  CLICK_NAV_SHORTCUT: 'click_navShortcut',
  CLICK_NAV_CART: 'click_navCart',
  CLICK_NAV_COUNTRY_SELECTION_SUCCESS: 'click_navCountrySelectionSuccess',
  CLICK_NAV_MOBILE_SHORTCUT: 'click_navMobileShortcut',
  CLICK_NAV_STORE_LOCATOR: 'click_navStoreLocator',
  CLICK_OPEN_MOBILE_MENU: 'click_openMobileMenu',
  CLICK_SEARCH_CLEAR: 'click_searchClear',
  CLICK_SEARCH_CLOSE: 'click_searchClose',
  CLICK_SEARCH_OPEN: 'click_searchOpen',
  CLICK_SEARCH_RECENT_DELETE: 'click_searchRecentDelete',
  CLICK_SEARCH_RECENT_SUBMIT: 'click_searchRecentSubmit',
  CLICK_POPULAR_SEARCH_SELECTION: 'click_popularSearchSelection',
  CLICK_CLOSE_MOBILE_MENU: 'click_closeMobileMenu',
  SUBMIT_USER_TYPED_SEARCH: 'submit_navOnsiteSearchUserTyped',
  ACTION_TYPE_AHEAD_SUGGESTIONS_SHOWN: 'action_typeaheadSuggestionShown',
  CLICK_TYPE_AHEAD_SUGGESTIONS: 'click_navOnsiteSearchTypeahead',
  CLICK_VISUAL_SEARCH_ITEM: 'visualSearchItemClick',
  ACTION_SEARCH_USER_EXPERIENCE_VIEWED: 'action_searchUserExperienceViewed',
};

export default AnalyticsEventTypes;
